import { createSelectionStore, type SelectionSnapshot, type SelectionStore } from "@rscircuit/editor-host";

let store: SelectionStore | null = null;

/** Process-wide selection store. Think reads this via `getSelection`; adapters write. */
export function getWorkbenchSelectionStore(): SelectionStore {
  if (!store) store = createSelectionStore();
  return store;
}

export function readWorkbenchSelection(): SelectionSnapshot | null {
  return store ? store.get() : null;
}

/** Test-only reset. */
export function resetWorkbenchSelectionStore(): void {
  store = null;
}
